export default function(api: GlobalFetch) {
  return async function() {
    const response: Response = await api.fetch('/api/v2/user/cookie')
    try {
      const json: any = await response.json()
      return json
    } catch (e) {
      return { messages: ['cookies status'], items: {} }
    }
  }
}
